const tenants = {
    title: 'Настройки',
    description: 'Эффективное управление настройками арендатора и настройка вашего домена.',
    oss_description: 'Измените настройки учетной записи и управляйте личной информацией здесь, чтобы обеспечить безопасность вашей учетной записи.',
    tabs: {
        settings: 'Настройки',
        members: 'Участники',
        domains: 'Домены',
        oidc_configs: 'Конфигурации OIDC',
        subscription: 'План и выставление счетов',
        billing_history: 'История выставления счетов',
        license: 'Лицензия',
    },
    license: {
        purchase_title: 'SELF-HOSTED ПЛАНЫ',
        purchase_description: 'Self-hosted Про и Корпоративный планы открывают платные возможности на вашем экземпляре: скрытие брендинга Logto, собственный интерфейс, совместная работа в консоли и неограниченное число SAML-приложений. Купите план, чтобы получить лицензионный ключ.',
        purchase_button: 'Посмотреть self-hosted планы',
        install_title: 'УСТАНОВКА ЛИЦЕНЗИИ',
        install_description: 'Вставьте лицензионный ключ, полученный после покупки self-hosted плана.',
        install_button: 'Установить лицензию',
        key_field: 'Лицензионный ключ',
        key_field_description: 'Ключ проверяется на вашем экземпляре и отправляется в Logto при обновлении лицензии. Обратитесь в Logto за новым ключом, если срок действия текущего истёк.',
        key_placeholder: 'Вставьте лицензионный ключ сюда',
        installed_toast: 'Лицензия успешно установлена.',
        details_title: 'ЛИЦЕНЗИЯ',
        details_description: 'Лицензия, установленная на этом экземпляре, и что она даёт.',
        plan_field: 'План',
        environment_field: 'Окружение',
        environment_production: 'Продакшн',
        environment_non_production: 'Не продакшн',
        expires_at_field: 'Действует до',
        installed_at_field: 'Установлена',
        last_refreshed_at_field: 'Последнее обновление',
        grace_ends_at_field: 'Льготный период заканчивается',
        refresh_expired_description: 'Срок действия лицензионного ключа истёк {{expiresAt}}. Лицензионные функции будут доступны до {{graceEndsAt}}, пока Logto пытается обновить ключ.',
        refresh_refused_description: 'Обновление лицензии отклонено, поскольку лицензия {{reason}}. Лицензионные функции будут доступны до {{graceEndsAt}}.',
        refusal_reason_canceled: 'отменена',
        refusal_reason_unpaid: 'не оплачена',
        refusal_reason_expired: 'истекла',
        refusal_reason_revoked: 'отозвана',
        refusal_reason_unknown: 'недоступна',
        grace_expired_description: 'Льготный период лицензии закончился {{graceEndsAt}}. Этот экземпляр вернулся к настройкам OSS по умолчанию. Обратитесь в Logto за новым лицензионным ключом и установите его снова.',
        get_fresh_key_button: 'Получить новый лицензионный ключ',
        replace_button: 'Заменить лицензию',
        usage_banner_description: 'Использование этого развёртывания превышает лимиты плана для самостоятельного размещения:',
        usage_banner_metric: '{{metric}}: {{value}} (лимит {{limit}})',
        usage_banner_action: 'Свяжитесь с нами в течение 30 дней, чтобы перейти на другой план или сократить использование.',
        usage_metric_mau: 'Месячная активная аудитория',
        usage_metric_access_tokens: 'Токены доступа за месяц',
        usage_metric_production_deployments: 'Производственные развёртывания',
    },
    members: {
        card_title: 'Управляйте арендаторами безопаснее с Logto Cloud',
        card_description: 'Добавляйте администраторов или участников в своего арендатора без совместного использования одной учетной записи администратора.',
        card_action: 'Открыть Logto Cloud',
        self_hosted_card_title: 'Управляйте арендаторами безопаснее с self-hosted планами',
        self_hosted_card_description: 'Добавляйте администраторов или участников в своего арендатора без совместного использования одной учетной записи администратора.',
        self_hosted_card_action: 'Открыть self-hosted планы',
    },
    settings: {
        title: 'НАСТРОЙКИ',
        description: 'Установите имя арендатора и просмотрите регион размещения данных и тип арендатора.',
        tenant_id: 'ID арендатора',
        tenant_name: 'Имя арендатора',
        tenant_instance: 'Выберите ваш экземпляр',
        tenant_instance_description: 'Выберите, где будет размещен ваш арендатор. Выберите Logto Cloud для общей публичной инфраструктуры или частный экземпляр для выделенных ресурсов.',
        tenant_region: 'Регион размещения данных',
        tenant_region_description: 'Физическое местоположение, где размещены ваши ресурсы арендатора (пользователи, приложения и т. д.). Это нельзя изменить после создания.',
        tenant_region_tip: 'Ваши ресурсы арендатора размещаются в {{region}}. <a>Узнайте больше</a>',
        environment_tag_development: 'Разр',
        environment_tag_production: 'Прод',
        tenant_type: 'Тип арендатора',
        development_description: 'Только для тестирования и не должно использоваться в производстве. Подписка не требуется. Он имеет все профессиональные функции, но с ограничениями, такими как баннер входа.',
        production_description: 'Предназначен для приложений, используемых конечными пользователями и может потребовать платную подписку.',
        tenant_info_saved: 'Информация о квартиросъемщике успешно сохранена.',
        tenant_mfa: 'Многофакторная аутентификация',
        tenant_mfa_description: 'Требуйте от участников настроить многофакторную аутентификацию для доступа к этому арендатору.',
        oss_description: 'Управляйте тем, как участники получают доступ к консоли на этом экземпляре.',
        tenant_mfa_confirm_title: 'Требовать MFA от всех участников?',
        tenant_mfa_confirm_description: 'Эти участники ещё не настроили MFA. Они останутся в системе, и при следующем входе им будет предложено её настроить:',
        tenant_mfa_confirm_self: 'Вы тоже ещё не настроили MFA. Настройте её в параметрах учётной записи до следующего входа.',
        tenant_mfa_confirm_button: 'Требовать MFA',
        tenant_mfa_setup_required: 'Этот арендатор требует многофакторную аутентификацию. Настройте её сейчас, иначе это потребуется при следующем входе.',
        tenant_mfa_setup_action: 'Настроить MFA',
        enterprise_sso: 'Enterprise SSO',
        enterprise_sso_description: 'Доступно в платных планах. Свяжитесь с нами, чтобы включить Enterprise SSO, чтобы все участники могли входить в консоль Logto Cloud, используя поставщика идентификации вашей организации.',
    },
    full_env_tag: {
        development: 'Разработка',
        production: 'Производство',
    },
    view_only: {
        tag: 'Только просмотр',
        notification: 'У вас есть доступ только для просмотра к этому арендатору. Обратитесь к администратору арендатора, если вам нужно внести изменения.',
        hidden: 'Скрыто от наблюдателей',
    },
    deletion_card: {
        title: 'УДАЛИТЬ',
        tenant_deletion: 'Удаление арендатора',
        tenant_deletion_description: 'Удаление арендатора приведет к окончательному удалению всех связанных пользовательских данных и настроек. Пожалуйста, действуйте осторожно.',
        tenant_deletion_button: 'Удалить арендатора',
    },
    leave_tenant_card: {
        title: 'ПОКИНУТЬ',
        leave_tenant: 'Покинуть арендатора',
        leave_tenant_description: 'Любые ресурсы арендатора останутся, но у вас больше не будет доступа к этому арендатору.',
        last_admin_note: 'Чтобы покинуть этот квартиросъемщик, убедитесь, что у еще как минимум одного участника есть роль администратора.',
    },
    create_modal: {
        title: 'Создать арендатора',
        subtitle: 'Создайте нового арендатора, у которого есть изолированные ресурсы и пользователи.',
        tenant_id: 'ID арендатора',
        tenant_usage_purpose: 'Для чего вы хотите использовать этот арендатор?',
        development_description: 'Только для тестирования и не должно использоваться в производстве. Подписка не требуется.',
        development_description_for_private_regions: 'Только для тестирования и не должно использоваться в производстве.',
        development_hint: 'Он имеет все профессиональные функции, но с ограничениями, такими как баннер входа.',
        production_description: 'Для использования конечными пользователями и может потребовать платную подписку.',
        available_plan: 'Доступный план:',
        create_button: 'Создать арендатора',
        tenant_name_placeholder: 'Мой арендатор',
        tenant_created: 'Арендатор успешно создан.',
        invitation_failed: 'Некоторые приглашения не удалось отправить. Пожалуйста, попробуйте снова в Настройки -> Участники позже.',
        tenant_type_description: 'Это нельзя изменить после создания.',
        tenant_id_invalid: 'Идентификатор арендатора может содержать только строчные буквы, цифры и дефисы и не должен превышать {{max}} символов.',
        tenant_id_placeholder: 'Идентификатор арендатора',
        tenant_id_tip: 'Настройте идентификатор арендатора. Если оставить пустым, Logto сгенерирует идентификатор по умолчанию. Идентификатор арендатора нельзя изменить после создания.',
    },
    dev_tenant_migration: {
        title: 'Теперь вы можете бесплатно попробовать наши профессиональные функции, создав новый "Development tenant"!',
        affect_title: 'Как это повлияет на вас?',
        hint_1: 'Мы заменяем старые <strong>теги окружения</strong> двумя новыми типами арендаторов: <strong>«Development»</strong> и <strong>«Production»</strong>.',
        hint_2: 'Для обеспечения бесперебойной работы и непрерывной функциональности все заранее созданные арендаторы будут переведены в тип арендатора <strong>Production</strong> вместе с вашей предыдущей подпиской.',
        hint_3: 'Не волнуйтесь, все ваши другие настройки останутся неизменными.',
        about_tenant_type: 'Об типе арендатора',
    },
    delete_modal: {
        title: 'Удалить арендатора',
        description_line1: 'Вы уверены, что хотите удалить вашего арендатора "<span>{{name}}</span>" с тегом окружения "<span>{{tag}}</span>"? Это действие нельзя отменить и приведет к окончательному удалению всех ваших данных и информации об арендаторе.',
        description_line2: 'Прежде чем удалять арендатора, возможно, мы можем вам помочь. <span><a>Связаться с нами по электронной почте</a></span>',
        description_line3: 'Если вы хотите продолжить, введите имя арендатора "<span>{{name}}</span>" для подтверждения.',
        delete_button: 'Навсегда удалить',
        cannot_delete_title: 'Нельзя удалить этого арендатора',
        cannot_delete_description: 'Извините, вы не можете удалить этого арендатора прямо сейчас. Пожалуйста, убедитесь, что вы используете бесплатный план и оплатили все невыполненные счета.',
    },
    leave_tenant_modal: {
        description: 'Вы уверены, что хотите покинуть этого арендатора?',
        leave_button: 'Покинуть',
    },
    tenant_landing_page: {
        title: 'Вы еще не создали арендатора',
        description: 'Чтобы начать настройку вашего проекта с помощью Logto, создайте нового арендатора. Если вам нужно выйти из системы или удалить свою учетную запись, просто нажмите на кнопку аватара в правом верхнем углу.',
        create_tenant_button: 'Создать арендатора',
    },
    status: {
        mau_exceeded: 'Превышение MAU',
        token_exceeded: 'Превышение токена',
        suspended: 'Приостановлен',
        overdue: 'Прошлый срок',
    },
    tenant_suspended_page: {
        title: 'Приостановленный арендатор. Свяжитесь с нами, чтобы восстановить доступ.',
        description_1: 'Очень сожалеем, но ваша учетная запись арендатора временно заблокирована из-за неправильного использования, включая превышение MAU-лимитов, просроченные платежи или другие неавторизованные действия.',
        description_2: 'Если вам нужна дополнительная информация или у вас возникли какие-либо вопросы или вы хотите восстановить полную функциональность и разблокировать своих арендаторов, не стесняйтесь немедленно связаться с нами.',
    },
    production_tenant_notification: {
        text: 'Вы находитесь в dev tenant для бесплатного тестирования. Создайте production tenant для запуска в эксплуатацию.',
        action: 'Создать арендатора',
    },
};
export default Object.freeze(tenants);
